import { useState, useEffect } from 'react'
import { useAuth } from '../../context/AuthContext'
import { tienePermiso, getRolDelUsuario } from '../../lib/permisos'
import { Navigate } from 'react-router-dom'
import { Lock } from 'lucide-react'

const ProtegerRuta = ({ modulo, permiso = 'ver', children }) => {
  const { user, loading } = useAuth()
  const [autorizado, setAutorizado] = useState(null)

  useEffect(() => {
    if (!user) { setAutorizado(false); return }
    const verificar = async () => {
      const rol = await getRolDelUsuario()
      if (rol === 'admin') { setAutorizado(true); return }
      const ok = await tienePermiso(rol, modulo, permiso)
      setAutorizado(ok)
    }
    verificar()
  }, [user, modulo, permiso])

  if (loading || autorizado === null) {
    return <div className="flex justify-center items-center h-64"><div className="w-8 h-8 border-3 border-gray-200 border-t-red-600 rounded-full animate-spin" /></div>
  }

  if (!user) return <Navigate to="/login" />
  if (!autorizado) {
    return (
      <div style={{ padding: 40, textAlign: 'center', fontFamily: "'Inter', sans-serif" }}>
        <div style={{ fontSize: '3rem', marginBottom: 16, display: 'flex', justifyContent: 'center' }}><Lock size={44} style={{ color: '#DC2626' }} /></div>
        <h2 style={{ color: '#991B1B', marginBottom: 8 }}>Acceso denegado</h2>
        <p style={{ color: '#6B7280' }}>No tienes permisos para acceder a esta sección.</p>
      </div>
    )
  }

  return children
}

export default ProtegerRuta